/**
 * Sub Navigation Component
 * Handles fixed positioning on scroll
 */
export class SubNav {
    constructor() {
        this.subNav = null;
        this.subHero = null;
        this.offsetTop = 0;
        this.isFixed = false;
    }

    init() {
        this.subNav = document.getElementById("sub-nav");
        this.subHero = document.querySelector(".no-sub-hero");

        if (!this.subNav || !this.subHero) return;

        // 초기 위치 계산
        this.calculateOffset();

        // 스크롤 이벤트 리스너
        this.initScrollHandler();

        // 활성 메뉴가 보이도록 스크롤 위치 조정 (Swiper 사용 시에는 Swiper init에서 slideTo 처리)
        if (!document.getElementById("sub-nav-swiper")) {
            this.scrollActiveIntoView();
        }

        // 리사이즈 이벤트 리스너
        window.addEventListener("resize", () => {
            this.calculateOffset();
        });
    }

    scrollActiveIntoView() {
        const scrollEl = document.getElementById("sub-nav-scroll");
        const active = this.subNav?.querySelector(".no-sub-nav__item.--active");
        if (!scrollEl || !active) return;

        const c = scrollEl.getBoundingClientRect();
        const a = active.getBoundingClientRect();
        const itemCenterInView = (a.left - c.left) + a.width / 2;
        const targetScroll = scrollEl.scrollLeft + itemCenterInView - c.width / 2;
        scrollEl.scrollLeft = Math.max(0, Math.min(targetScroll, scrollEl.scrollWidth - scrollEl.clientWidth));
    }

    calculateOffset() {
        if (!this.subHero || !this.subNav) return;
        const heroRect = this.subHero.getBoundingClientRect();
        const navRect = this.subNav.getBoundingClientRect();
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        // sub-hero의 하단에서 sub-nav의 높이만큼 뺀 위치
        this.offsetTop =
            heroRect.top + scrollTop + heroRect.height - navRect.height;
    }

    initScrollHandler() {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollTop =
                        window.pageYOffset ||
                        document.documentElement.scrollTop;

                    if (scrollTop >= this.offsetTop && !this.isFixed) {
                        this.subNav.classList.add("--fixed");
                        this.isFixed = true;
                    } else if (scrollTop < this.offsetTop && this.isFixed) {
                        this.subNav.classList.remove("--fixed");
                        this.isFixed = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
    }
}
